import type { TPageTranslations } from '@crehana/i18n';

import { PAGE_KEY } from './constants';
import type { TKeys } from './types';

export const pt: TPageTranslations<TKeys, typeof PAGE_KEY> = {
  [PAGE_KEY]: {
    TITLE: 'Widget',
    hoy: 'Hoje',
    t_registrado: 'T. registrado',
    marcar_ingreso: 'Registrar entrada',
    iniciar_almuerzo: 'Iniciar almoco/intervalo',
    finalizar_almuerzo: 'Finalizar almoco/intervalo',
    salir: 'Sair',
    error_carga_title: 'Ocorreu um erro ao carregar',
    error_carga_desc:
      'Clique no botao para tentar carregar o conteudo novamente.',
    reintentar: 'Tentar novamente',
    ingreso: 'Entrada',
    inicio_almuerzo_descanso: 'Inicio do almoco/intervalo',
    fin_almuerzo_descanso: 'Fim do almoco/intervalo',
    salida: 'Saida',
    sin_registro: 'Sem registro',
    registro_recibido: 'Registro recebido',
    cancelar: 'Cancelar',
    continuar: 'Continuar',
    alerta_sin_turno_title: 'Tem certeza de que deseja registrar sua entrada?',
    alerta_sin_turno_desc:
      'Voce ainda nao tem um turno atribuido para hoje; pode continuar com o registro e entrar em contato com seu administrador para obter mais informacoes.',
    alerta_ingreso_no_iniciado_title:
      'Tem certeza de que deseja registrar sua entrada?',
    alerta_ingreso_no_iniciado_desc:
      'Voce esta registrando sua entrada fora do horario atribuido, pois o horario de entrada do seu proximo turno ainda nao comecou.',
    alerta_salida_antes_title: 'Tem certeza de que deseja registrar sua saida?',
    alerta_salida_antes_desc:
      'Sair antes do seu horario pode afetar sua presenca, por isso sugerimos relatar qualquer eventualidade ao seu administrador.',
    detalles_del_registro: 'Detalhes do registro',
    dia: 'Dia',
    turno_asignado: 'Turno atribuido',
    evento_registrado: 'Evento registrado',
    hora_del_registro: 'Hora do registro',
    hora_estimada: 'Hora estimada',
    hora_registro_tooltip:
      'A hora do registro pode ser ajustada automaticamente de acordo com as regras da sua empresa. Consulte seu administrador para mais informacoes.',
    success_ingreso: 'Voce registrou sua entrada com sucesso.',
    success_salida: 'Voce registrou sua saida com sucesso.',
    success_break_start:
      'Voce registrou o inicio do seu almoco/intervalo com sucesso.',
    success_break_end:
      'Voce registrou o fim do seu almoco/intervalo com sucesso.',
    warning_late:
      'Voce registrou seu(a) {{event}} apos o horario estabelecido.',
    warning_early:
      'Voce registrou seu(a) {{event}} antes do horario estabelecido.',
    error_generic: 'Ocorreu um erro ao registrar a presenca, tente novamente.',
    error_duplicate:
      'Este evento ja foi registrado em outro dispositivo e nao e possivel marca-lo novamente.',
    cerrar: 'Fechar',
    sin_turno: 'Sem turno atribuido',
    tiempo_registrado: 'Tempo registrado',
    tiempo_esperado: 'Tempo esperado',
    registro_fuera_rango: 'Registro fora do intervalo esperado',
    mi_asistencia: 'Minha presenca',
    mi_equipo: 'Minha equipe',
    ver_modulo: 'Ver modulo',
    registra_tu_asistencia: 'Registre sua presenca para o turno de hoje.',
    turno_completado: 'Turno concluido',
    a_tiempo: 'No horario',
    aceptable: 'Aceitavel',
    retardo_o_falta: 'Atraso ou falta',
    salida_anticipada: 'Saida antecipada',
    fuera_de_horario: 'Fora do horario',
    sin_calculo: 'Sem calculo',

    // new keys
    date_time_display_today: 'Hoje',

    registered_mark_modal_title: 'Detalhes do registro',
    registered_mark_modal_success_banner_message:
      'Voce registrou seu {{markName}} com sucesso.',
    registered_mark_modal_delay_banner_message:
      'Voce registrou seu {{markName}} apos o horario estabelecido.',
    registered_mark_modal_early_banner_message:
      'Voce registrou seu {{markName}} antes do horario estabelecido.',
    registered_mark_modal_error_default:
      'Ocorreu um erro ao registrar a presenca, tente novamente.',
    registered_mark_modal_error_duplicate:
      'Este evento ja foi registrado em outro dispositivo e nao e possivel marca-lo novamente.',
    registered_mark_modal_row_without_shift: 'Sem turno atribuido',
    registered_mark_modal_row_day: 'Dia',
    registered_mark_modal_row_shift: 'Turno atribuido',
    registered_mark_modal_row_event: 'Evento registrado',
    registered_mark_modal_row_time: 'Hora do registro',
    registered_mark_modal_row_estimated_time: 'Hora estimada',
    registered_mark_modal_row_tooltip:
      'A hora do registro pode ser ajustada automaticamente de acordo com as regras da sua empresa. Consulte seu administrador para mais informacoes.',
    registered_mark_modal_row_retry: 'Tentar novamente',
    registered_mark_modal_row_cancel: 'Cancelar',

    timer_circle_today: 'Hoje',
    timer_circle_hours_outside_schedule: 'Horas fora do intervalo esperado',
    timer_circle_t_registered: 'T. registrado',
    timer_circle_time_registered: 'Tempo registrado',
    timer_circle_time_expected: 'Tempo esperado',

    dialog_button_continue: 'Continuar',
    dialog_button_cancel: 'Cancelar',

    confirm_mark_no_shift_title:
      'Tem certeza de que deseja registrar sua entrada?',
    confirm_mark_no_shift_description:
      'Voce ainda nao tem um turno atribuido para hoje; pode continuar com o registro e entrar em contato com seu administrador para obter mais informacoes.',
    confirm_mark_early_entry_title:
      'Tem certeza de que deseja registrar sua entrada?',
    confirm_mark_early_entry_description:
      'Voce esta registrando sua entrada fora do horario atribuido, pois o horario de entrada do seu proximo turno ainda nao comecou.',
    confirm_mark_early_exit_title:
      'Tem certeza de que deseja registrar sua saida?',
    confirm_mark_early_exit_description:
      'Sair antes do seu horario pode afetar sua presenca, por isso sugerimos relatar qualquer eventualidade ao seu administrador.',

    mark_event_entry: 'Entrada',
    mark_event_break_start: 'Inicio do almoco/intervalo',
    mark_event_break_end: 'Fim do almoco/intervalo',
    mark_event_exit: 'Saida',

    action_buttons_mark_entry: 'Registrar entrada',
    action_buttons_mark_break_start: 'Registrar inicio do almoco/intervalo',
    action_buttons_mark_break_end: 'Registrar fim do almoco/intervalo',
    action_buttons_mark_exit: 'Sair',

    widget_header_tabs_personal: 'Minha presenca',
    widget_header_tabs_team: 'Minha equipe',
    widget_header_link_view_module: 'Ver modulo',

    widget_no_leader_title: 'Minha presenca',
    widget_no_leader_subtitle: 'Registre sua presenca para o turno de hoje.',

    team_table_column_user: 'Usuário',
    team_table_column_shift: 'Turno',
    team_table_column_status: 'Status',
    team_table_column_scheduled_time: 'Horário programado',

    team_table_status_without_mark: 'Sem registro',
    team_table_status_entry_marked: 'Entrou',
    team_table_status_break_start_marked: 'Em almoço / intervalo',
    team_table_status_break_end_marked: 'Voltou do almoço / intervalo',
    team_table_status_exit_marked: 'Saiu',
    team_table_status_shift_break: 'Descanso de turno',
    team_table_status_without_shift: 'Sem turno atribuído',

    team_table_scheduled_time_not_applicable: 'Não se aplica',

    team_table_error_title: 'Ocorreu um erro ao carregar',
    team_table_error_description:
      'Clique no botão para tentar carregar o conteúdo novamente.',
    team_table_error_retry: 'Tentar novamente',
    team_table_empty_title: 'Sem membros da equipe',
    team_table_empty_description: 'Não há membros da equipe para exibir.',
  },
};
